import styled from 'styled-components';

export const InfomenuContainer = styled.div``;

export const InfomenuContent = styled.div`
  width: 300px;
`;

export const InfomenuImage = styled.div`
  > img {
    border-radius: 8px;
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const InfomenuContentWrapper = styled.div`
  padding: 20px 8px 8px;
`;

export const InfomenuTitle = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.color.ui2};
  ${({ theme }) => theme.font.t1};
  line-height: 120%;
  margin-bottom: 8px;
`;

export const InfomenuDesc = styled.div`
  ${({ theme }) => theme.font.t2};
  line-height: 20px;
  display: flex;
  align-items: center;
  text-align: center;

  color: ${({ theme }) => theme.color.ui2};

  p {
    margin: 0;
    margin-top: 10px;
  }
`;

export const InfomenuFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
